// @core/api/endpoints/authn/update_password.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  UpdatePasswordRequest,
} from '../../../types/authn';

const BASE_PATH = '/authn';

/**
 * Update user password (requires current password)
 * Changes the user's password after verifying the current password. Requires password confirmation to prevent typos. May trigger security notifications to the user.
 */
export async function UpdatePassword(
  data: UpdatePasswordRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/auth/password`;
  const requestOptions = options;
  return client.put<Response>(requestPath, data, requestOptions);
}
